import ErrorMessage from "components/ErrorMessage";
import Loader from "layout/Loader";
import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from 'react-select';
import { useTranslation } from "react-i18next";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import FormValidation from "utils/formValidation";
import helpers from "utils/helpers";
import { validationRules } from "utils/constants";
import PhoneInput from "react-phone-input-2";
import { isEmpty } from "lodash";
import FileUploadInput from "components/reusable/FileUploadInput";
import { apiGet, apiPost } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import axios from "axios";
import useToastContext from "hooks/useToastContext";
import {
  useJsApiLoader,
  Autocomplete
} from '@react-google-maps/api';
import { FaLocationCrosshairs } from "react-icons/fa6";
const libraries = ["places"]
function Register() {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries
  })
  const [defaultAuto, setDefaultAuto] = useState('')
  const [steps, setSteps] = useState(helpers.getLocalStorage('steps') || '1')
  const pickupInputRef = useRef(null)
  const pickupAutocomplete = useRef(null);
  const notification = useToastContext();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [icon, setIcon] = useState(true);
  const [icon1, setIcon1] = useState(true);
  const [countryCode] = useState("us");
  const inputRef = useRef(null);
  const [isRegisterData, setIsRegisterData] = useState(helpers.getLocalStorage('registerData'))
  const [serviceCategory, setServiceCategory] = useState([])

  const {
    register,
    handleSubmit,
    trigger,
    setValue, clearErrors,
    reset,
    watch,
    control,
    formState: { errors },

  } = useForm({ shouldUnregister: true, mode: "onChange", shouldFocusError: true, defaultValues: {}, });

  const {
    register: register1,
    handleSubmit: handleSubmit1,
    control: control1,
    formState: { errors: errors1 },

  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const formValidation = FormValidation()
  const preventSpace = (e) => {
    if (e?.which === 32) {
      e.preventDefault();
    }
  };

  const customStyles = {
    option: (provided) => ({
      ...provided,
      fontSize: '13px',
      zIndex: 9999
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: '14px',
    }),
    container: (provided) => ({
      ...provided,
      fontSize: '14px',
    }),
    control: (provided) => ({
      ...provided,
      minHeight: 53,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 999,
      top: '-5px'
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 999,
    }),

  };
  function changeIcon() {
    setIcon(!icon);
  }

  function changeIcon1() {
    setIcon1(!icon1);
  }

  const handleFirstStep = (e) => {
    e.mobile = e?.mobile?.substring(inputRef?.current?.state.selectedCountry?.countryCode?.length, e?.mobile?.toString()?.length);
    e.countryCode = inputRef?.current?.state.selectedCountry?.countryCode;
    e.specialtyServices=serviceCategory
    setIsRegisterData(e)
    helpers.setLocalStorage('registerData', e)
    helpers.setLocalStorage('steps', '2')
    setSteps('2')
  }


  const readFileAsArrayBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  };


  const getPreSignUrl = async (file) => {
    try {
      const payloadPre = {
        contentType: file?.type,
      };
      const path = apiPath.generatePeoviderPreSignUrl;
      const result = await apiPost(path, payloadPre);
      if (result?.data?.success) {
        const buffer = await readFileAsArrayBuffer(file);
        const resp = await axios.put(result?.data?.results?.url, buffer, {
          headers: {
            "Content-Type": file.type || "application/octet-stream",
          },
        });

        if (resp?.status === 200) {
          return result?.data?.results;
        }
      }
    } catch (error) {
      console.error("--------error------------", error);
    }
  }

  const getFileValue = (val) => {
    console.log('val', val)

    if (val?.length > 0) return val[0];
    if (typeof val === "string") return val;
    return '';
  }





  const handleUseCurrentLocation = () => {

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (pos) => {

        const coords = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
        setValue('longitude', coords?.lng)
        setValue('latitude', coords?.lat)
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: coords }, (results, status) => {
          if (status === 'OK' && results[0]) {
            setDefaultAuto(results?.[0]?.formatted_address)
            if (pickupInputRef.current) pickupInputRef.current.value = results?.[0]?.formatted_address
            setValue('address', results?.[0]?.formatted_address)
            setValue('addressCordinate', results?.[0]?.formatted_address)
            clearErrors('addressCordinate')

          }
        });


      });
    }
  };


  const handlePlaceChanged = () => {

    const pickupPlace = pickupAutocomplete.current?.getPlace();
    let pickupLoc = {}

    if (pickupPlace?.geometry?.location) {
      pickupLoc = {
        lat: pickupPlace.geometry.location.lat(),
        lng: pickupPlace.geometry.location.lng()
      };

      setValue('longitude', pickupLoc?.lng)
      setValue('latitude', pickupLoc?.lat)
      setValue('addressCordinate', pickupPlace?.formatted_address)
      setValue('address', pickupPlace?.formatted_address)
      clearErrors('addressCordinate')
    }

  };



  const [isPending, setPending] = useState(false)
  const handleRegister = async (e) => {
    try {
      const files = {
        vehicleRegistrationFront: getFileValue(e.vehicleRegistrationFront),
        vehicleRegistrationBack: getFileValue(e.vehicleRegistrationBack),
        vehicleInsurancePolicy: getFileValue(e.vehicleInsurancePolicy),
        governmentIDFront: getFileValue(e.governmentIDFront),
        governmentIDBack: getFileValue(e.governmentIDBack),
        serviceCertificate: getFileValue(e.serviceCertificate),
        serviceCertificateBack: getFileValue(e.serviceCertificateBack),
      };



      const uploadedUrls = {
        businessRegistrationCertificateDocFront: '',
        businessRegistrationCertificateDocBack: '',
        companyInsurancePolicyDoc: '',
        truckDOTNumberDocFront: '',
        truckDOTNumberDocBack: '',
        licenseDocFront: '',
        licenseDocBack: ''
      };

      setPending(true)
      for (const key in files) {
        const file = files[key];

        if (typeof file !== 'string') {
          const presignedUrl = await getPreSignUrl(file);
          if (!presignedUrl?.key) {
            throw new Error(`Upload failed for ${key}`);
          }
          switch (key) {
            case 'vehicleRegistrationFront':
              uploadedUrls.businessRegistrationCertificateDocFront = presignedUrl.key;
              break;
            case 'vehicleRegistrationBack':
              uploadedUrls.businessRegistrationCertificateDocBack = presignedUrl.key;
              break;
            case 'vehicleInsurancePolicy':
              uploadedUrls.companyInsurancePolicyDoc = presignedUrl.key;
              break;
            case 'governmentIDFront':
              uploadedUrls.licenseDocFront = presignedUrl.key;
              break;
            case 'governmentIDBack':
              uploadedUrls.licenseDocBack = presignedUrl.key;
              break;
            case 'serviceCertificate':
              uploadedUrls.truckDOTNumberDocFront = presignedUrl.key;
              break;
            case 'serviceCertificateBack':
              uploadedUrls.truckDOTNumberDocBack = presignedUrl.key;
              break;
          }
        }
      }

      const payload = {
        routingNumber: e?.routingNumber,
        swiftCode: e?.swiftCode,
        accountNumber: e?.accountNumber,
        ...uploadedUrls,
        ...isRegisterData,
        specialtyServices: isRegisterData?.specialtyServices?.map((res) => res?.value)
      };
    
      const resp = await apiPost(apiPath.register, payload);
      if (resp?.data?.success) {
        notification.success(resp?.data?.message)
        navigate('/login')
        helpers.removeLocalStorage('registerData')
        helpers.removeLocalStorage('steps')
        setPending(false)
        return
      }
      notification.error(resp?.data?.message)
      setPending(false)

    } catch (err) {
      console.log('Error in handleRegister:', err);
      setPending(false)
    }

  };


  const getServiceCategory = async () => {
    try {

      const resp = await apiGet(apiPath.getMasterCategory)
      if (resp?.data?.success) {
        setServiceCategory(resp?.data?.results?.services?.map((res) => ({ label: res?.name, value: res?._id })))
        return
      }
      setServiceCategory([])
    } catch (err) {
      console.log('-----errr----', err)
    }

  }

  useEffect(() => {
    getServiceCategory()

  }, [])


  useEffect(() => {
    if (!isEmpty(isRegisterData)) {
      reset({ ...isRegisterData, address: isRegisterData?.address, longitude: isRegisterData?.longitude, latitude: isRegisterData?.latitude, mobile: helpers.ternaryCondition(isRegisterData?.countryCode, isRegisterData?.countryCode + isRegisterData?.mobile, "na") })
      setValue('addressCordinate', isRegisterData?.address)
      setValue('accountType', isRegisterData?.accountType)
      setDefaultAuto(isRegisterData?.address)
    }
  }, [isRegisterData, steps,])


  const accountType = watch('accountType') || 'individual';


  return (
    <div className="bg-gradientTo Auth_Background signUp_Page_overflow">
      <Loader />
      {helpers.andOperator(isPending, <div id='loader' className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999] ">
        <div className="w-8 h-8 border-4 border-gray-300 border-t-gray-600 border-t-transparent rounded-full animate-spin"></div>
        <span className='visually-hidden ml-2 text-black'>Loading...</span>
      </div>)}
      <div className="p-4 max-w-[800px] mx-auto pt-10 flex flex-col justify-center h-screen2">
        <figure className="text-center mb-8">
          <Link to="/login" className="inline-block">
            <img src="/images/fasttow.png" alt="logoRegister" className="w-[173px] h-[60px] mx-auto"/>
          </Link>
        </figure>

        <div className=" rounded-[20px] overflow-hidden"><div className="">
          <div className="register-form bg-white  rounded-[20px]">
            <div className="bg-[#F3F3F3] p-6">
              <h4 className="text-xl mb-3 font-bold text-[#151513]">
                {t("REGISTRATION")}
              </h4>
              <div className="">
                <ul className="relative inline-block register-page-step">
                  <li className="inline-block text-center pe-[100px] sm:pe-[164px] relative z-10">
                    <span className="inline-flex items-center justify-center w-[30px] h-[30px] rounded-full border border-[#DFDFDF] bg-white mx-auto cursor-pointer" onClick={() => { setSteps('1'); helpers.setLocalStorage('steps', '1') }}>
                      <small className="bg-[#00C582] w-6 h-6 rounded-full inline-flex items-center justify-center">
                        <img src="/images/tickIcon.svg" alt="tickIcon" />
                      </small>
                    </span>
                    <p className="mt-[6px]">{t("STEP_1")}</p>
                  </li>

                  <li className="inline-block text-center relative z-10">
                    <span className="inline-flex items-center justify-center w-[30px] h-[30px] rounded-full border border-[#DFDFDF] bg-white mx-auto ">
                      <small className={`bg-[#00C582] w-6 h-6 rounded-full inline-flex items-center justify-center ${helpers.andOperator(steps == '1', 'scale-0 transition-all')}`}>
                        <img src="/images/tickIcon.svg" alt="tickIcon" />
                      </small>
                    </span>
                    <p className="text-dark mt-[6px]">{t("STEP_2")}</p>
                  </li>
                </ul>
              </div>
            </div>
            {helpers.ternaryCondition(steps == '1',
              <form className="" onSubmit={handleSubmit(handleFirstStep)}>
                <div className="p-6">

                  <h4 className="mb-3 font-bold text-[#151513]">{t("CONTINUE_WITH")}</h4>
                  <div className="mb-7">

                    <div className="flex mb-2">
                      <label className="flex items-center me-6 cursor-pointer">
                        <input
                          type="radio"
                          name="accountType"
                          value="individual"
                          {...register('accountType', { required: "Please select account type.",})}
                          className="w-5 h-5 peer opacity-0 absolute"
                          checked={accountType === "individual"}
                        />
                        <span className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center relative after:bg-[#E89F34] after:w-3 after:h-3 after:rounded-full after:opacity-0 peer-checked:border-[#E89F34] peer-checked:after:opacity-100"></span>
                        <span className="ms-2 text-sm text-gray-900 dark:text-gray-900">Individual</span>
                      </label>

                      <label className="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="accountType"
                          value="company"
                          {...register('accountType', { required: "Please select account type."})}
                          className="w-5 h-5 peer opacity-0 absolute"
                          checked={accountType === "company"}
                        />
                        <span className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center relative after:bg-[#E89F34] after:w-3 after:h-3 after:rounded-full after:opacity-0 peer-checked:border-[#E89F34] peer-checked:after:opacity-100"></span>
                        <span className="ms-2 text-sm text-gray-900 dark:text-gray-900">{t("COMPANY")}</span>
                      </label>
                    </div>

                    <ErrorMessage message={errors?.accountType?.message} />
                  </div>

                  <div className="sm:grid grid-cols-2 gap-6">

                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type="text"
                        id="fullName"
                        className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        name="fullName"
                        {...register("fullName",
                          formValidation.fullNameSP)}
                      />

                      <label
                        htmlFor="fullName"
                        className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("OWNERS_FULL_NAME")}
                        <span className="text-red-500">*</span>
                      </label>
                      <ErrorMessage message={errors?.fullName?.message} />
                    </div>

                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type="text"
                        id="companyName"
                        className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        name="companyName"
                        {...register("companyName",formValidation.companyName)}
                      />

                      <label
                        htmlFor="companyName"
                        className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("COMPANY_NAME")}
                        <span className="text-red-500">*</span>
                      </label>
                      <ErrorMessage message={errors?.companyName?.message} />
                    </div>


                    <div className="relative z-0 w-full group mb-3 sm:mb-0 z-50">
                      <Controller
                        control={control}
                        name="mobile"
                        rules={{
                          required: t("PLEASE_ENTER_MOBILE_NO"),
                          validate: (value) => {
                            const inputValue = value?.toString()?.slice(inputRef?.current?.state?.selectedCountry?.countryCode?.length, value?.length);
                            if (inputValue?.length < 7) {
                              return t("MOBILE_NO_GREATER");
                            } else if (inputValue?.length > 15) {
                              return t("MOBILE_NO_EX");
                            }
                          },
                        }}
                        render={({ field: { ref, ...field } }) => (
                          <PhoneInput
                            {...field}
                            inputExtraProps={{
                              ref,
                              required: true,
                              autoFocus: true,
                            }}
                            ref={inputRef}
                            inputStyle={{
                              width: "100%",
                              height: "54px",
                            }}

                            style={{ borderRadius: "20px" }}
                            country={countryCode}
                            enableSearch={false}
                            onlyCountries={["us"]}
                            countryCodeEditable={false}
                          />
                        )}
                      />
                      <ErrorMessage message={errors?.mobile?.message} />
                    </div>

                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type="text"
                        id="email"
                        className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        name="email"
                        onKeyDown={(e) => preventSpace(e)}
                        {...register("email",
                          formValidation.email)}
                      />

                      <label
                        htmlFor="email"
                        className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("O_EMAIL_ID")}
                        <span className="text-red-500">*</span>
                      </label>
                      <ErrorMessage message={errors?.email?.message} />
                    </div>

                    <div className="relative z-0 w-full group mb-3 sm:mb-0 hidden">
                      <Controller
                        name="specialtyServices"
                        control={control}
                        // rules={{ required: 'Please select at least one service.' }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={serviceCategory}
                            isMulti
                            placeholder={`Select Specialty Services*`}
                            classNamePrefix="react-select"
                            className="react-select-container "
                            styles={customStyles}
                            menuPortalTarget={document.body}
                          />
                        )}
                      />
                      <ErrorMessage message={errors?.specialtyServices?.message} />
                    </div>

                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type="number"
                        name="yearOfExperience"
                        id="yearOfExperience"
                        className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        step={0.1}
                        {...register("yearOfExperience", {
                          required: false,
                          max: { value: 100, message: 'Year of experience cannot greater than 100.' },
                          min: { value: 0.1, message: 'Year of experience must be greater than 0.' },

                          onChange: (e) => {
                            let value = e.target.value;

                            // Remove invalid characters (allow only digits and .)
                            value = value.replace(/[^0-9.]/g, '');

                            // Allow only one decimal point
                            const parts = value.split('.');
                            if (parts.length > 2) {
                              value = parts[0] + '.' + parts[1];
                            }

                            // Limit to 2 digits after decimal
                            if (parts[1]) {
                              value = parts[0] + '.' + parts[1].slice(0, 2);
                            }

                            e.target.value = value;
                          }

                        })}
                        onKeyDown={(e) => {
                          if ([",", "e", "-"].includes(e.key)) e.preventDefault();
                        }}
                      />
                      <label
                        htmlFor="yearOfExperience"
                        className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("Years of Experience")}
                        {/* <span className="text-red-500">*</span> */}
                      </label>

                      <ErrorMessage message={errors?.yearOfExperience?.message} />
                    </div>


                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type={icon ? "password" : "text"}
                        name="password"
                        id="password"
                        maxLength={40}
                        className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        autoComplete="new-password"
                        {...register("password", {
                          required: t("PLEASE_ENTER_PASSWORD"),
                          validate: {
                            whiteSpace: (value) => value.trim() ? true : t('WHITE_SPACES_NOT_ALLOWED')
                          },
                          pattern: {
                            value: validationRules.password,
                            message:
                              t("PASSWORD_PATTERN"),
                          },
                          onChange: (e) => { trigger('confirmPassword') }
                        })}
                      />
                      <label
                        htmlFor="password"
                        className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("O_PASSWORD")}
                        <span className="text-red-500">*</span>
                      </label>
                      {icon ? (
                        <span
                          className=" password_view cursor-pointer absolute top-[18px] right-[20px]"
                          onClick={() => changeIcon()} >
                          <AiFillEyeInvisible />
                        </span>
                      ) : (
                        <span
                          className=" password_view absolute top-[18px] right-[20px]"
                          onClick={() => changeIcon()}>
                          <AiFillEye />
                        </span>
                      )}
                      <ErrorMessage message={errors?.password?.message} />
                    </div>

                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type={icon1 ? "password" : "text"}
                        name="confirmPassword"
                        id="confirmPassword"
                        maxLength={40}
                        className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        autoComplete="confirmPassword"
                        {...register("confirmPassword", {
                          required: t("PLEASE_ENTER_CONFIRM_PASSWORD"),

                          pattern: {
                            value: validationRules.password,
                            message:
                              t("CONFIRM_PASSWORD_PATTERN"),
                          },

                          validate: (val) => {
                            if (watch("password") !== val) {
                              return "Confirm Password field is not matching with password field.";
                            }
                          },
                        })}
                      />
                      <label
                        htmlFor="confirmPassword"
                        className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("O_CONFIRM_PASSWORD")}
                        <span className="text-red-500">*</span>
                      </label>
                      {icon1 ? (
                        <span
                          className=" password_view cursor-pointer absolute top-[18px] right-[20px]"
                          onClick={() => changeIcon1()} >
                          <AiFillEyeInvisible />
                        </span>
                      ) : (
                        <span
                          className="password_view absolute top-[18px] right-[20px]"
                          onClick={() => changeIcon1()}>
                          <AiFillEye />
                        </span>
                      )}
                      <ErrorMessage message={errors?.confirmPassword?.message} />
                    </div>



                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type={"text"}
                        name="caNumber"
                        id="caNumber"
                        maxLength={40}
                        className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        autoComplete="caNumber"
                        {...register("caNumber",formValidation.caNumberSP )}
                      />
                      <label
                        htmlFor="caNumber"
                        className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("CA_NUMBER")}
                        <span className="text-red-500">*</span>
                      </label>
                     
                      <ErrorMessage message={errors?.caNumber?.message} />
                    </div>
                    


                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type={"text"}
                        name="truckDOTNumber"
                        id="truckDOTNumber"
                        maxLength={40}
                        className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        autoComplete="truckDOTNumber"
                        {...register("truckDOTNumber",formValidation.truckDOTNumber )}
                      />
                      <label
                        htmlFor="truckDOTNumber"
                        className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("TRUCK_DOT_NUMBER")}
                        <span className="text-red-500">*</span>
                      </label>
                     
                      <ErrorMessage message={errors?.truckDOTNumber?.message} />
                    </div>


                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input type='text' className="hidden"
                        {...register('addressCordinate', { required: "Please enter business address." })} />
                      {helpers.ternaryCondition(isLoaded,
                        <Autocomplete
                          onPlaceChanged={handlePlaceChanged}
                          onLoad={(autocomplete) => (pickupAutocomplete.current = autocomplete)}>
                          <span className="flex justify-between pe-2 border border-[#DADADA] relative rounded-lg" >

                            <input
                              type="text"
                              ref={pickupInputRef}
                              defaultValue={defaultAuto}

                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                }
                              }}
                              placeholder={t('SEARCH_LOCATION')}
                              className="bg-transparent border-0 flex-1 py-4 focus:outline-none placeholder:text-theme-black px-4 h-[52px] text-[15px]"
                            />
                            <button className="bg-transparent border-0 w-5 flex-shrink-0" type='button' onClick={handleUseCurrentLocation}>
                              <FaLocationCrosshairs />
                            </button>
                          </span>

                        </Autocomplete>, <div className="w-full  bg-gray-200 animate-pulse rounded-lg mb-3 mt-3 flex justify-center items-center">Loading Google Maps...</div>)}
                      <ErrorMessage message={errors?.addressCordinate?.message} />
                    </div>

                  </div>
                </div>
                <div className="py-4 px-6 sm:flex items-center border-t border-t-[#DFDFDF]">
                  <button className="bg-[#151513] px-12 py-3 rounded-[10px] text-white" type='submit'>
                    Next
                  </button>
                  <p className=" pt-3 sm:pt-0 sm:ps-5"><span className="text-sm">  {t("ALREADY_ACCOUNT")}, </span><Link to='login' className="text-[#6236FF] hover:text-[#9D36FF] hover:underline text-sm font-medium">{t("SIGN_IN")}</Link></p>

                </div>
              </form>,

              <form className="" onSubmit={handleSubmit1(handleRegister)}>
                <div className="p-6 ">
                  <div className="sm:grid grid-cols-2 gap-6">
                   
                      <div>
                        <h4 className="mb-1 font-bold text-[#151513]">
                          {t("BUSINESS_REGISTRATION")}
                        </h4>
                        <p className="text-sm">
                          {t("BUSINESS_REGISTRATION_CLEAR_COPY")}
                        </p>
                        <div className="flex flex-wrap md:grid grid-cols-3 gap-3 pt-2">
                          <div>
                            <FileUploadInput
                              label="Upload Front"
                              name="vehicleRegistrationFront"
                              control={control1}
                              rules={{
                                required: "Business registration certificate (front) is required.",
                                validate: {
                                  acceptedFormats: (file) =>
                                    file && ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                    || "Business registration certificate (front) accept only JPG, PNG, JPEG files.",
                                  fileSize: (file) =>
                                    file && file[0]?.size <= 5 * 1024 * 1024 || "Business registration certificate (front) must be less than 5MB."
                                }
                              }}
                              accept=".jpg,.jpeg,.png"
                            />

                          </div>

                          <div>
                            <FileUploadInput
                              label="Upload Back"
                              name="vehicleRegistrationBack"
                              control={control1}
                              rules={{
                                required: "Business registration certificate (back) is required.",
                                validate: {
                                  acceptedFormats: (file) =>
                                    file && ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                    || "Business registration certificate (back) accept only JPG, PNG, JPEG files.",
                                  fileSize: (file) =>
                                    file && file[0]?.size <= 5 * 1024 * 1024 || "Business registration certificate (back) must be less than 5MB."
                                }
                              }}
                              accept=".jpg,.jpeg,.png"
                            />


                          </div>
                        </div>
                        <ErrorMessage message={errors1?.vehicleRegistrationFront?.message} />
                        <ErrorMessage message={errors1?.vehicleRegistrationBack?.message} />
                      </div>
                      <div>
                        <h4 className="mb-1 font-bold text-[#151513]">
                          {t("COMPANY_INSURANCE_POLICY")}
                        </h4>
                        <p className="text-sm">
                          {t("VALID_COMPANY_INSURANCE_POLICY")}
                        </p>
                        <div className="flex flex-wrap md:grid grid-cols-3 gap-3 pt-2">
                          <div>
                            <FileUploadInput
                              label="Upload PDF"
                              name="vehicleInsurancePolicy"
                              control={control1}
                              rules={{
                                required: "Company insurance policy is required.",
                                validate: {
                                  acceptedFormats: (file) =>
                                    file && ["application/pdf"].includes(file[0]?.type)
                                    || "Company insurance policy accept only PDF file.",
                                  fileSize: (file) =>
                                    file && file[0]?.size <= 10 * 1024 * 1024 || "Company insurance policy must be less than 10MB."
                                }
                              }}
                              accept=".pdf"
                              fileType='pdf'
                            />
                          </div>
                        </div>
                        <ErrorMessage message={errors1?.vehicleInsurancePolicy?.message} />
                      </div>
                    
                    <div>
                      <h4 className="mb-1 font-bold text-[#151513]">
                      Owner’s Driving License
                      </h4>
                      <p className="text-sm">
                      Valid government-issued identification document
                      </p>
                      <div className="flex flex-wrap md:grid grid-cols-3 gap-3 pt-2">
                        <div>
                          <FileUploadInput
                            label="Upload Front"
                            name="governmentIDFront"
                            control={control1}
                            rules={{
                              required: "Owner's driving license (front) is required.",
                              validate: {
                                acceptedFormats: (file) =>
                                  file && ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                  || "Owner's driving license (front) accept only JPG, PNG, JPEG files.",
                                fileSize: (file) =>
                                  file && file[0]?.size <= 5 * 1024 * 1024 || "Owner's driving license (front) must be less than 5MB."
                              }
                            }}
                            accept=".jpg,.jpeg,.png"
                          />
                        </div>
                        <div>
                          <FileUploadInput
                            label="Upload Back"
                            name="governmentIDBack"
                            control={control1}
                            rules={{
                              required: "Owner's driving license (back) is required.",
                              validate: {
                                acceptedFormats: (file) =>
                                  file && ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                  || "Owner's driving license (back) accept only JPG, PNG, JPEG files.",
                                fileSize: (file) =>
                                  file && file[0]?.size <= 5 * 1024 * 1024 || "Owner's driving license (back) must be less than 5MB."
                              }
                            }}
                            accept=".jpg,.jpeg,.png"
                          />
                        </div>
                      </div>
                      <ErrorMessage message={errors1?.governmentIDFront?.message} />
                      <ErrorMessage message={errors1?.governmentIDBack?.message} />
                    </div>

                    {/* <div>
                      <h4 className="mb-1 font-bold text-[#151513]">
                        {t("TRUCK_DOT_NUMBER")}
                      </h4>
                      <p className="text-sm">
                        {t("TRUCK_DOT_NUMBER_CERTIFICATIONS")}
                      </p>

                      <div className="flex flex-wrap md:grid grid-cols-3 gap-3 pt-2">
                        <div>
                          <FileUploadInput
                            label="Upload Front"
                            name="serviceCertificate"
                            control={control1}
                            rules={{
                              required: "Truck dot number certificate (front) is required.",
                              validate: {
                                acceptedFormats: (file) =>
                                  file && ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                  || "Truck dot number certificate (front) accept only JPG, PNG, JPEG files.",
                                fileSize: (file) =>
                                  file && file[0]?.size <= 5 * 1024 * 1024 || "Truck dot number certificate (front) must be less than 5MB."
                              }
                            }}
                            accept=".jpg,.jpeg,.png"
                          />
                        </div>
                        <div>
                          <FileUploadInput
                            label="Upload Back"
                            name="serviceCertificateBack"
                            control={control1}
                            rules={{
                              required: "Truck dot number certificate (back) is required.",
                              validate: {
                                acceptedFormats: (file) =>
                                  file && ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                  || "Truck dot number certificate (back) accept only JPG, PNG, JPEG files.",
                                fileSize: (file) =>
                                  file && file[0]?.size <= 5 * 1024 * 1024 || "Truck dot number certificate (back) must be less than 5MB."
                              }
                            }}
                            accept=".jpg,.jpeg,.png"
                          />
                        </div>
                      </div>
                      <ErrorMessage message={errors1?.serviceCertificate?.message} />
                      <ErrorMessage message={errors1?.serviceCertificateBack?.message} />
                    </div> */}
                  </div>
                 
                </div>

                <div className="py-4 px-6 sm:flex items-center border-t border-t-[#DFDFDF]">
                  <button className="bg-[#151513] px-12 py-3 rounded-[10px] text-white" type='submit'>
                    {helpers.ternaryCondition(isPending, 'Submitting..', 'Submit')}
                  </button>
                  <p className="pt-3 sm:pt-0 sm:ps-5">
                    {t("ALREADY_ACCOUNT")}{" "}
                    <Link to="/login" className="text-[#4C64E0]">
                      {t("SIGN_IN")}
                    </Link>
                  </p>
                </div>
              </form>)}
          </div>
        </div>
        </div>,

      </div>
    </div >
  );
}

export default Register;
